"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var icon_1 = require("./icon");
Object.defineProperty(exports, "Icon", { enumerable: true, get: function () { return icon_1.Icon; } });
//# sourceMappingURL=index.js.map